import React from 'react'

import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Bar from '../../../../components/pdf/Bar'

const Header = () => (
  <>
    <Grid justify="space-between" align="center">
      <Col>
        <Image src="/btime-logo-roxo.png" maxWidth={100} ignoreFixedSize />
      </Col>
    </Grid>
    <Bar />
  </>
)

export default Header
